import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Mexico Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  isViewShipmentURLModified: true,
  analyticsRangeDownloadPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  date: "formatted_payment_date",
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  exportPDFInAnalyticsFrontend: true,
  minimumDateAllowed: "2011-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { label: "Weight (kg)", value: "weight", value1: "weight", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("mexicoImportLatestArrivalDate"),
    getSearchResult: getApiUrl("mexicoImportSearch"),
    getAnalyticsData: getApiUrl("analytics/mexicoImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_mexico_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_mexico_imports"),
    getShipmentByID: getApiUrl("mexicoImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfMexicoImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/mexicoImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchMexicoImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.mx_import.country_small,
  countryCaps: globalCountryDetails.mx_import.country_caps,
  product_id: globalCountryDetails.mx_import.product_id,
  compare_product_id: globalCountryDetails.mx_import.compareProduct,
  country_CamelCase: globalCountryDetails.mx_import.product_id,
  countryCode: globalCountryDetails.mx_import.countryCode,
  countryType: globalCountryDetails.mx_import.countryType,
  manyCountryType: globalCountryDetails.mx_import.manyCountryType,
  countryTypeCode: globalCountryDetails.mx_import.countryTypeCode,
  redirectionID: globalCountryDetails.mx_import.redirectionID,
  analyticsCountryID: globalCountryDetails.mx_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Tax Payment Date Range",
  monthRangeHeading: "Month of Import",
  onboardingText: {
    reacttourDateRange: "Customize your shipment basis payment date",
    reacttourFilterH: "Filters Button",
    reacttourFilterP: "Use filters to get most relevant shipments for you",
    reacttourMainSearchH: "Start searching for Mexico Imports Shipments",
    reacttourMainSearchP: "HS Codes and Consignees",
    navTabP: "View unique importers in the search result and add them to your prospect list.",
    savedSearchButtonP: "Reload from Saved Searches, for quick shipments data access.",
  },
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
    reports: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.mx_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    // portOfLading: "standardLadingPortName",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    countryOfOriginRegion: "countryOfOriginRegion",
    consignee: "consignee",
    consigneeCity: "consigneeCity",
    consigneeStateRegion: "consigneeStateRegion",
    consigneeZipcode: "consigneeZipcode",
    shipper: "shipper",
    shipperCity: "shipperCity",
    shipperState: "shipperState",
    shipperCountryRegion: "shipperCountryRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    standardUnladingPortName: "standardUnladingPortName",
    customHouseNameCode: "customHouseNameCode",
    customsHouseState: "customsHouseState",
    customsRegime: "customsRegime",
    incoterm: "incoterm",
    modeOfTransport: "modeOfTransport",
    shipmentValue: "shipmentValue",
    hsCode: "hsCode",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    isExporter: "isExporter",
    isImporter: "isImporter",
    sixDigitHsCode: "sixDigitHsCode",
    weight: "weight",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    weight: "weight",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    weight: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfOriginRegion: "countryOfOrigin",
    consigneeStateRegion: "consigneeState",
    shipperCountryRegion: "shipperCountry",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfOriginRegion: [],
    consignee: [],
    consigneeCity: [],
    consigneeStateRegion: [],
    consigneeZipcode: [],
    shipper: [],
    shipperCity: [],
    shipperState: [],
    shipperCountryRegion: [],
    countryOfDestinationRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    standardUnladingPortName: [],
    customHouseNameCode: [],
    customsHouseState: [],
    customsRegime: [],
    incoterm: [],
    modeOfTransport: [],
    shipmentValue: [],
    hsCode: [],
    sections: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    isImporter: [],
    isExporter: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    weight: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfOriginRegion: false,
    consignee: false,
    consigneeCity: false,
    consigneeStateRegion: false,
    consigneeZipcode: false,
    shipper: false,
    shipperCity: false,
    shipperState: false,
    shipperCountryRegion: false,
    countryOfDestinationRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    standardUnladingPortName: false,
    customHouseNameCode: false,
    customsHouseState: false,
    customsRegime: false,
    incoterm: false,
    modeOfTransport: false,
    shipmentValue: false,
    sections: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    isImporter: false,
    isExporter: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    weight: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "16", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "17", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "1", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee City ", categoryName: "consigneeDetails", eventKey: "2", key: "consigneeCity", type: filterType.normalFilter, label: "Consignee City", viewAllPlaceHolder: "Search in Consignee City Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee State ", categoryName: "consigneeDetails", eventKey: "3", key: "consigneeStateRegion", altKey: "consigneeState", type: "localization-filter", label: "Consignee State", viewAllPlaceHolder: "Search in Consignee State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Zipcode ", categoryName: "consigneeDetails", eventKey: "4", key: "consigneeZipcode", type: filterType.normalFilter, label: "Consignee Zipcode", viewAllPlaceHolder: "Search in Consignee Zipcode Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Country of Origin", categoryName: "shipperDetails", eventKey: "5", key: "countryOfOriginRegion", altKey: "countryOfOrigin", type: "localization-filter", label: "Country of Origin", viewAllPlaceHolder: "Search in Country of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name ", categoryName: "shipperDetails", eventKey: "6", key: "shipper", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper City ", categoryName: "shipperDetails", eventKey: "7", key: "shipperCity", type: filterType.normalFilter, label: "Shipper City", viewAllPlaceHolder: "Search in Shipper City Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper State ", categoryName: "shipperDetails", eventKey: "8", key: "shipperState", type: filterType.normalFilter, label: "Shipper State", viewAllPlaceHolder: "Search in Shipper State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export ", categoryName: "shipperDetails", eventKey: "8", altKey: "countryOfOrigin", key: "countryOfOriginRegion", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import ", categoryName: "consigneeDetails", eventKey: "8", altKey: "countryOfDestination", key: "countryOfDestinationRegion", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading ", categoryName: "ports", eventKey: "9", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search in Port of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs House", categoryName: "ports", eventKey: "18", key: "customHouseNameCode", type: filterType.normalFilter, label: "Customs House", viewAllPlaceHolder: "Search in Customs House Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs House State ", categoryName: "ports", eventKey: "10", key: "customsHouseState", type: filterType.normalFilter, label: "Customs House State", viewAllPlaceHolder: "Search in Customs House State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Regime ", categoryName: "ports", eventKey: "11", key: "customsRegime", type: filterType.normalFilter, label: "Customs Regime", viewAllPlaceHolder: "Search in Customs Regime Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation ", categoryName: "freightType", eventKey: "12", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Incoterm ", categoryName: "freightType", eventKey: "33", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
    { heading: "Filter by Shipment Value (USD) ", categoryName: "cargoDetails", eventKey: "13", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "14", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code ", categoryName: "cargoDetails", eventKey: "14", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: "cargoDetails", eventKey: "20", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "6", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "pedimento_number_str", label: "Pedimento Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "mexican_trading_entity_business_name", label: "Consignee Name" },
    { key: "mexican_trading_entity_tax_identification_number", label: "Consignee Tax Identification Number" },
    { key: "mexican_trading_entity_address", label: "Consignee Address" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "foreign_trading_entity_name", label: "Shipper Name" },
    { key: "foreign_trading_entity_registration_number", label: "Shipper Tax Identification Number" },
    { key: "foreign_trading_entity_address", label: "Shipper Address" },
    { key: "customs_broker_code", label: "Customs Broker Code" },
    { key: "customs_broker_code_str", label: "Customs Broker Code" },
    { key: "product_description_translated", label: "Product Description" },
    { key: "product_description_spanish", label: "Product Description (Spanish)" },
    { key: "product_description_english_ml", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_house_name", label: "Port of Unlading" },
  ],
  shipmentSorting: [
    { columnKey: "formatted_payment_date", value: "date", isDefault: true },
    { columnKey: "commercial_invoice_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "formatted_payment_date",
    shipment_value: "commercial_invoice_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Imported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfOriginRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_origin_destination_country_english", filterKey: "countryOfOriginRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "customs_house_name" },
    { key: "customs_house_name", filterKey: "standardUnladingPortName", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "mexican_trading_entity_state", filterKey: "consigneeStateRegion", label: "Consignee States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
    // { key: "trade_country", filterKey1: "countryOfOriginRegion", filterKey2: "consigneeStateRegion", label: "Trade Routes (Country of Import → Consignee State)", headerOne: "Country of Import", headerTwo: "State of Consignee", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: "trade_port", filterKey1: "countryOfOriginRegion", filterKey2: "standardUnladingPortName", label: "Trade Routes (Country of Import → Port of Unlading)", headerOne: "Country of Import", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
    { key: "customs_house_name_code", filterKey: "customHouseNameCode", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "formatted_payment_date", name: "Tax Payment Date", selector: "formatted_payment_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description_spanish", name: "Product", selector: "product_description_spanish", tooltipValue: "product_description_spanish", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_quantity_unit_english", alternateSelector: "commercial_invoice_quantity", alternateSelectorUnit: "commercial_invoice_quantity_unit_spanish", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_consignee_mastername", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "mexican_trading_entity_business_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "foreign_trading_entity_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "foreign_trading_entity_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_origin_destination_country_english", name: "Country Of Origin", selector: "derived_origin_destination_country_english", dataTip: "", type: "", grow: 1, wrap: true, isFirstLetterCapital: true, miWidth: "120px", maWidth: "120px" },
    { key: "commercial_invoice_value_usd", name: "Shipment Value (USD)", selector: "commercial_invoice_value_usd", dataTip: "commercial_invoice_value_peso", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    // { key: "country", showUiUeTwoLevel: false, name: "Country", selector: "country", dataTip: "", type: "", isFirstLetterCapital: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 2, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, sortable: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, sortable: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2, grow: 1, wrap: true, sortable: true },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Tax Payment Date", value: "formatted_payment_date", dateFormat: true, monthFormat: false },
        { label: "Entry Date", value: "formatted_entry_date", dateFormat: true, preValidate: true, monthFormat: false },
        { label: "Pedimento Number", value: "pedimento_number_str" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english" },
        { label: "Incoterm", value: "incoterm_description", tooltip: true, tooltipField: "incoterm", preValidate: true },
        { label: "HS Code", value: "derived_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        // { label: "Country of Origin", value: "derived_origin_destination_country_english" },
        { label: "Shipper Standardized Name", type: "redirect", companyKey: "derived_shipper_master_name", companyIdKey: "derived_shipper_master_company_id", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
        { label: "Shipper Name", value: "foreign_trading_entity_name" },
        { label: "Shipper Registration Number", value: "foreign_trading_entity_registration_number", preValidate: true },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Shipper State", value: "derived_foreign_trading_entity_state", preValidate: true },
        { label: "Shipper City", value: "derived_foreign_trading_entity_city", preValidate: true },
        { label: "Shipper Zipcode", value: "derived_foreign_trading_entity_zipcode", preValidate: true },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", preValidate: true },
        { label: "Shipper Address", value: "foreign_trading_entity_address" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_customs_house_name", tooltip: false, tooltipField: "customs_house_code", tooltipPrefix: "Custom House Code: ", tooltipValue: "", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "consignee_name", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
        { label: "Consignee Name", value: "mexican_trading_entity_business_name" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Tax Identification Number", value: "mexican_trading_entity_tax_identification_number" },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee State", value: "mexican_trading_entity_state" },
        { label: "Consignee City", value: "derived_mexican_trading_entity_municipality" },
        { label: "Consignee Zipcode", value: "derived_mexican_trading_entity_postal_code" },
        { label: "Consignee Address", value: "mexican_trading_entity_address" },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs Broker Code", value: "customs_broker_code" },
        { label: "Customs House", value: "derived_customs_house_name_code" },
        { label: "Customs House State", value: "derived_customs_house_state" },
        { label: "Customs Regime", value: "derived_customs_classification_english", tooltip: true, tooltipField: "customs_classification_code", tooltipValue: "" },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Sequence Number", value: "secuencia", preValidate: true },
        { label: "Product Description", value: "product_description_translated", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_description_spanish", isReadMore: true, readMoreLength: 45 },
        { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, valueSuffix: "", preValidate: true },
        { label: "Commercial Invoice Quantity", value: "commercial_invoice_quantity", unitField: "derived_commercial_invoice_quantity_unit_english", dynamicUnit: true, valueSuffix: "" },
        { label: "Commercial Invoice  Value", value: "commercial_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "commercial_invoice_value_peso", tooltipPrefix: "PESO ", tooltipValue: "", preValidate: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance", value: "SEGUROS", valuePrefix: "USD ", preValidate: true },
        { label: "Freight Value (USD)", value: "derived_pedimento_freight_usd", valuePrefix: "USD ", preValidate: true },
        { label: "Value (USD)", value: "value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "value_peso", tooltipPrefix: "PESO ", tooltipValue: "", preValidate: true },
        { label: "Weight", value: "derived_weight_kg", valueSuffix: " kg", isCommaFormat: true },
        { label: "Pedimento Gross Weight", value: "gross_weight_kg", valueSuffix: " kg" },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Mexico Imports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique importers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_origin_destination_country_english",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    mexican_trading_entity_state: "Consignee States",
    derived_mode_of_transport_english: "Mode of Transportation",
    // trade_port: "Trade Routes (Country of Import → Port of Unlading)",
    // trade_country: "Trade Routes (Country of Import → Mexico State of Consignee)",

    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_origin_destination_country_english: "Countries of Origin",
    customs_house_name: "Port of Unlading",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const MexicoImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default MexicoImportSearch;
